import { render } from "./HeroiconsSolidCog.vue?vue&type=template&id=d808a8ec"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCog.vue"]])

export default __exports__